import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import defaultState from './state'

const store = createStore(defaultState, applyMiddleware(thunk))
export default store